import {
  IAutocomplete,
  IFieldType,
  IFormButtons,
  IFormFields,
  ISex,
} from "shared/types";
import { copy } from "shared/assets";
import { isoToDateString } from "shared/utils";
import { IUser } from "Auth/types";

const { authFormFields: fieldsCopy, errors } = copy;

export const getFormFields = (
  showChangeEmail: () => void,
  showChangePassword: () => void,
  showOtherInfo: boolean
): IFormFields => {
  const fields: IFormFields = [
    {
      name: "personalInfo",
      style: {
        gridTemplateColumns: "1fr 1fr",
      },
      hideContainer: true,
      fields: [
        {
          name: "firstname",
          label: fieldsCopy.firstName,
          type: IFieldType.text,
          autocomplete: IAutocomplete.givenName,
          validation: {
            required: errors.required,
          },
        },
        {
          name: "lastname",
          label: fieldsCopy.lastName,
          type: IFieldType.text,
          autocomplete: IAutocomplete.familyName,
          validation: {
            required: errors.required,
          },
        },
      ],
    },
    {
      name: "loginInfo",
      style: {
        gridTemplateColumns: "1fr 1fr",
      },
      hideContainer: true,
      fields: [
        {
          name: "email",
          label: fieldsCopy.email,
          type: IFieldType.email,
          disabled: true,
          fieldLink: {
            label: copy.form.change,
            onClick: showChangeEmail,
            "data-testid": "change_email_button",
          },
        },
        {
          name: "password",
          label: fieldsCopy.password.title,
          type: IFieldType.text,
          disabled: true,
          fieldLink: {
            label: copy.form.change,
            onClick: showChangePassword,
          },
        },
      ],
    },
  ];

  if (showOtherInfo) {
    fields.push({
      name: "otherInfo",
      style: {
        gridTemplateColumns: "1fr 1fr",
        mobile: {
          gridTemplateColumns: "1fr",
        },
      },
      hideContainer: true,
      fields: [
        {
          type: IFieldType.radioGroup,
          name: "sex",
          label: fieldsCopy.sex.label,
          options: [
            {
              label: fieldsCopy.sex.options.male,
              value: ISex.m,
            },
            {
              label: fieldsCopy.sex.options.female,
              value: ISex.f,
            },
            {
              label: fieldsCopy.sex.options.other,
              value: ISex.x,
            },
          ],
          style: {
            gridColumn: "span 2",
            mobile: {
              gridColumn: "span 1",
            },
          },
        },
        {
          name: "birthDate",
          label: fieldsCopy.birthDate,
          type: IFieldType.simpleDate,
          autocomplete: IAutocomplete.bday,
          validation: {
            minLength: {
              value: 10,
              message: errors.birthDate,
            },
            maxLength: {
              value: 10,
              message: errors.birthDate,
            },
          },
        },
        {
          name: "birthCountry",
          label: fieldsCopy.birthCountry,
          type: IFieldType.country,
        },
        {
          name: "nationality",
          label: fieldsCopy.nationality,
          type: IFieldType.country,
        },
      ],
    });
  }

  return fields;
};

export const getDefaultValues = (currentUser?: IUser | null) => {
  const {
    firstname,
    lastname,
    email,
    sex,
    birthDate,
    birthCountry,
    nationality,
  } = currentUser?.attributes || {};

  return {
    personalInfo: {
      firstname,
      lastname,
    },
    loginInfo: {
      email,
      password: "••••••••",
    },
    otherInfo: {
      sex,
      birthDate: birthDate ? isoToDateString(birthDate) : null,
      birthCountry,
      nationality,
    },
  };
};

export const buttons: IFormButtons = {
  primary: true,
  secondary: false,
};
